enum CostUnitPaymentTypeEnum {
  ADJUSTMENT = 3,
  ADVANCE = 1,
  COPAYMENT_COMPENSATION = 9,
  COPAYMENT_COMPENSATION_CAR_DEALER = 10,
  FINALPAYMENT = 4,
  FINALPAYMENT_WITHOUT_COPAYMENT = 8,
  INSTALLMENT = 2,
  INSURANCE_REGULATION = 6,
  SETTLEMENT = 5,
  VAT_COMPENSATION = 7,
  UNKNOWN = 999
}

export default CostUnitPaymentTypeEnum;
